import "core-js/modules/es.array.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-4cba79c2"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "free"
};
var _hoisted_2 = {
  class: "top"
};

var _hoisted_3 = /*#__PURE__*/_createTextVNode(" Riscern Free ");

var _hoisted_4 = {
  key: 0
};
var _hoisted_5 = {
  class: "info"
};

var _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"list\" data-v-4cba79c2><div data-v-4cba79c2><div class=\"item\" data-v-4cba79c2><span class=\"high-text\" data-v-4cba79c2></span>Company Registration Information</div><div class=\"item\" data-v-4cba79c2><span class=\"high-text\" data-v-4cba79c2></span>Up to 10 companies a day</div><div class=\"item\" data-v-4cba79c2><span class=\"high-text\" data-v-4cba79c2></span>Up to 50 companies a month</div></div></div>", 1);

var _hoisted_7 = {
  class: "change-plan"
};

var _hoisted_8 = /*#__PURE__*/_createTextVNode(" Cancel Plan ");

var _hoisted_9 = /*#__PURE__*/_createTextVNode(" Upgrade ");

import { useRouter } from 'vue-router';
import { computed } from 'vue';
import { changePlanStatus } from './data';
export default /*#__PURE__*/_defineComponent({
  props: {
    currentData: Object,
    userCardData: Object,
    status: String
  },
  setup: function setup(__props) {
    var props = __props;
    var router = useRouter();

    function handleUpgrade() {
      router.push({
        name: 'ResourcesPlans'
      });
    }

    function handleCancel() {
      changePlanStatus.value = 2;
      document.documentElement.scrollTop = 0;
    } // 订阅中 / 升级中


    var userSubscribIng = computed(function () {
      var _ref = props.currentData || {},
          subscribeStatus = _ref.subscribeStatus;

      return [1, 5].includes(subscribeStatus);
    });
    return function (_ctx, _cache) {
      var _component_el_button = _resolveComponent("el-button");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _unref(userSubscribIng) ? (_openBlock(), _createElementBlock("span", _hoisted_4, "Payment processing")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, [__props.status === 'available' ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        type: "primary",
        class: "project-btn",
        onClick: handleCancel
      }, {
        default: _withCtx(function () {
          return [_hoisted_8];
        }),
        _: 1
      })) : !_unref(userSubscribIng) ? (_openBlock(), _createBlock(_component_el_button, {
        key: 1,
        type: "primary",
        class: "project-btn",
        onClick: handleUpgrade
      }, {
        default: _withCtx(function () {
          return [_hoisted_9];
        }),
        _: 1
      })) : _createCommentVNode("", true)])])]);
    };
  }
});